import {
    CircleUser,
    Users,
    Briefcase,
    Building2,
    Github, Settings2
} from 'lucide-angular';
import {ActualURLPaths} from "../../../models/routes-constants";

export interface SideNavItem {
    label: string;
    route: string;
    icon?: any; // lucide icons
    matIcon?: string; // material icons
}

export interface SideNavSection {
    title: string;
    items: SideNavItem[];
}

export const SETTINGS_SIDENAV: SideNavSection[] = [
    {
        title: 'PERSONAL',
        items: [
            { label: 'Profile', route: ActualURLPaths.PROFILE_SETTINGS, icon: CircleUser },
            { label: 'Preferences', route: ActualURLPaths.PREFERENCES, icon: Settings2 }
        ]
    },
    {
        title: 'ADMIN PANEL',
        items: [
            { label: 'Teams', route: ActualURLPaths.MANAGE_TEAMS, icon: Users },
            { label: 'Projects', route: ActualURLPaths.PROJECTS, icon: Briefcase },
            { label: 'Organization', route: ActualURLPaths.MANAGE_ORG_MEMBERS, icon: Building2 }
        ]
    },
    // {
    //     title: 'Workflow',
    //     items: [
    //         { label: 'Team Preference', route: '/settings/team-preference', icon: Settings2 }
    //     ]
    // },
    {
        title: 'INTEGRATIONS',
        items: [
            { label: 'GitHub', route: ActualURLPaths.INTEGRATE_GITHUB, icon: Github },
            { label: 'Jira', route: ActualURLPaths.JIRA_UPLOAD, matIcon: 'jira' }
        ]
    }
];
